import { render, staticRenderFns } from "./PasswordChange.vue?vue&type=template&id=adc777e2&"
import script from "./PasswordChange.vue?vue&type=script&lang=ts&"
export * from "./PasswordChange.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports